import React from 'react'

const techStack = [
  // Row 1
  { name: "Python",           icon: { type: "img", src: "https://cdn.simpleicons.org/python" } },
  { name: "JavaScript",       icon: { type: "devicon", cls: "devicon-javascript-plain colored" } },
  { name: "TypeScript",       icon: { type: "devicon", cls: "devicon-typescript-plain colored" } },
  { name: "Swift",            icon: { type: "devicon", cls: "devicon-swift-plain colored" } },
  // Row 2
  { name: "Robot",            icon: { type: "img", src: "https://cdn.simpleicons.org/robotframework" } },
  { name: "React",            icon: { type: "devicon", cls: "devicon-react-original colored" } },
  { name: "Playwright",       icon: { type: "devicon", cls: "devicon-playwright-plain colored" } },
  { name: "XCUITest",         icon: { type: "devicon", cls: "devicon-xcode-plain colored" } },
]

function TechIcon({ icon }) {
  if (icon.type === "img") {
    return <img src={icon.src} alt="" className="w-10 h-10 block" />
  }
  return <i className={`${icon.cls} text-[2.4rem] leading-none block`}></i>
}

export default function TechStack() {
  return (
    <div className="pb-10">
      <p className="text-sm font-bold tracking-widest text-title mb-6">STACK</p>
      <div className="flex justify-between">
        {techStack.map(({ name, icon }) => (
          <div key={name} className="flex flex-col items-center gap-2.5 group cursor-default">
            <div className="w-[75px] h-[75px] flex items-center justify-center rounded-2xl bg-surface group-hover:scale-110 group-hover:shadow-md transition-all duration-200">
              <TechIcon icon={icon} />
            </div>
            <span className="text-[0.72rem] font-medium text-muted text-center leading-tight">
              {name}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
